<div class="autocomplete" appClickOutside (clickOutside)="hideList()">
  <div class="search-field" [ngClass]="{'is-active': listvisible, 'is-focus': inputIsFocus}">
    <div class="autocomplete_content" [ngClass]="{'is-multi': multiselect}">
      <!-- Sélection en mode multi-->
      @if (multiselect) {
        @for (id of selectedIdList; track id) {
          <div class="autocomplete_multi-container">
            <div class="autocomplete_multi-content">
              @if (selectedTemplate) {
                <ng-container [ngTemplateOutlet]="selectedTemplate"
                  [ngTemplateOutletContext]="{$implicit: normalizeData(getItemFromCache(id))}">
                </ng-container>
              } @else {
                <div [ngClass]="isElementSupprimable(id) ? 'chips' : 'chips-not-deletable'">
                  <p>{{getLibelleById(id)}}</p>
                </div>
              }
            </div>
            @if (isElementSupprimable(id)) {
              <span (click)="removeElement(id)" class="autocomplete_multi-remove"><i
              class="icon icon-x"></i></span>
            }
          </div>
        }
      }
      <!--    Sélection en mode simple-->
      @if (selectedId != null && !multiselect) {
        <div class="autocomplete_chip"
          [ngClass]="{'is-disabled' : isDisabled}">
          <div class="autocomplete_chip-content">
            @if (selectedTemplate) {
              <ng-container [ngTemplateOutlet]="selectedTemplate"
                [ngTemplateOutletContext]="{$implicit: normalizeData(getItemFromCache(selectedId))}">
              </ng-container>
            } @else {
              {{getLibelleById(selectedId)}}
            }
          </div>
        </div>
      }
      @if (!isDisabled) {
        <input class="autocomplete_input" type="text" [ngModel]="searchTerm"
          (ngModelChange)="requestSearchUpdate($event)" (focus)="inputIsFocus = true" (blur)="inputIsFocus = false"
          (keydown.backspace)="clearSelectionIfInputEmpty()" (keydown.arrowDown)="changeRow(1)"
          (keydown.arrowUp)="changeRow(-1)"
          (keydown.enter)="selectElementByIndexWhenDropDownVisible(rowselected); hideList()"
          [ngClass]="{'has-chips': selectedId != null}">
      }
    </div>
    @if (!isDisabled) {
      <div class="autocomplete_dropdown" (click)="dropDown()">
        <i class="icon icon-chevron-down"></i>
      </div>
    }
  </div>
  <!--  Liste de résultats -->
  @if (listvisible) {
    <div class="autocomplete_results">
      <ul class="autocomplete_list">
        @for (elt of searchList; track elt; let i = $index) {
          <li class="autocomplete_item -liste" (click)="selectElement(elt)"
            [className]="getCodeCouleur(elt)"
            [ngClass]="{'is-selected': i == rowselected, 'is-disabled': this.isAlreadySelected(elt)}"
            (mouseenter)="selectRow(i)">
            @if (itemTemplate) {
              <ng-container [ngTemplateOutlet]="itemTemplate"
                [ngTemplateOutletContext]="{$implicit: normalizeData(elt)}">
              </ng-container>
            } @else {
              {{getItemLibelle(elt)}}
            }
          </li>
        }
        @if (isParticipant && isAuthorized) {
          <li class="autocomplete_item -new" (click)="addPerson()">
            <span class="icon-container">
              <i class="icon icon-add"></i>
            </span>
            <span>
              Créer le participant
              <span class="name">
                {{searchTerm}}
              </span>
            </span>
          </li>
        }
        @if (isAxesAnalytiques && isAuthorized) {
          <li class="autocomplete_item -new" (click)="addAxesAnalytique()">
            <span class="icon-container">
              <i class="icon icon-add"></i>
            </span>
            <span>
              Créer la section
              <span class="name">
                {{searchTerm}}
              </span>
            </span>
          </li>
        }
      </ul>
    </div>
  }
</div>